import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function StatsSection() {
  const {
    t
  } = useLanguage();
  const stats = [{
    value: '45%',
    label: t('stats.conversions'),
    description: t('stats.conversions.desc')
  }, {
    value: '80%',
    label: t('stats.time'),
    description: t('stats.time.desc')
  }, {
    value: '20-50%',
    label: t('stats.revenue'),
    description: t('stats.revenue.desc')
  }];
  return <section className="py-16 lg:py-24 bg-[#0a0e1a]" data-id="element-248">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-249">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16" data-id="element-250">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-251">
            {t('stats.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-252">
            {t('stats.subtitle')}
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-253">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-254">
              <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#ff6b35] mb-3" data-id="element-255">
                {stat.value}
              </div>
              <div className="text-xl font-semibold text-white mb-2" data-id="element-256">
                {stat.label}
              </div>
              <p className="text-gray-400" data-id="element-257">{stat.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}